import { api } from "../AxiosInstance";
import { urlQueryBuilder } from "../utils/urlQueryBuilder";

const TripHistoryService = {
  getTripHistoryStats: async (options: { signal?: AbortSignal } = {}) => {
    try {
      const response = await api.get("/job-history/trip-stats", options);
      return response.data;
    } catch (error) {
      console.error("Error getTripHistoryStats:", error);
      throw error;
    }
  },
  getTripHistory: async (
    queryParams: {
      status?: string;
      skip?: number;
      limit?: number;
      jobBreakupDetailId?: string;
      containerNumber?: string;
      from?: number | null;
      to?: number | null;
      signal?: AbortSignal;
    } = {}
  ) => {
    console.log("getTripHistory");
    console.log(queryParams);
    try {
      const { signal, ...params } = queryParams;
      const queryString = urlQueryBuilder(params);
      console.log(queryString);
      const response = await api.get(
        `/job-history/trips${queryString ? `?${queryString}` : ""}`,
        { signal }
      );
      if (!response || !response.data) {
        throw new Error("Invalid response from server");
      }
      return response;
    } catch (error) {
      console.error("Error getTripHistory:", error);
      throw error;
    }
  },
  uploadExcelFile: async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await api.post("/trip-history/excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      console.error("Error uploading excel file:", error);
      throw error;
    }
  },
};

export default TripHistoryService;
